/// <reference types="vite/client" />

interface ProductVariantWithComponentsFields {
  product: {
    title: string;
    handle: string;
    featuredImage: {
      url: string;
    };
  };
  id: string;
  title: string;
  availableForSale: boolean;
  compareAtPrice: {
    currencyCode: string;
    amount: number;
  };
  price: {
    currencyCode: string;
    amount: number;
  };
  image: {
    url: string;
  };
  groupedBy: {
    nodes: {
      productVariant: ProductVariantWithComponentsFields;
      quantity: number;
    }[];
  };
  components: {
    nodes: {
      productVariant: ProductVariantWithComponentsFields;
      quantity: number;
    }[];
  };
}

const fragments = `
fragment ProductFields on Product {
  handle
  id
  title
  featuredImage {
    url
  }
}

fragment ProductVariantFields on ProductVariant {
  id
  title
  availableForSale
  compareAtPrice {
    currencyCode
    amount
  }
  price {
    currencyCode
    amount
  }
  image {
    url
  }
}

fragment ProductVariantGroupBy on ProductVariant {
  ...ProductVariantFields
  product {
    ...ProductFields
  }
  components(first: 10) {
    nodes {
      productVariant {
        ...ProductVariantFields
        product {
          ...ProductFields
        }
      }
      quantity
    }
  }
}


fragment ProductVariantWithComponentsFields on ProductVariant {
  ...ProductVariantFields
  groupedBy(first: 10) {
    nodes {
      ...ProductVariantGroupBy
    }
  }

  components(first: 10) {
    nodes {
      productVariant {
        ...ProductVariantFields
        product {
          ...ProductFields
        }
      }
      quantity
    }
  }
}`;

const storefrontAccessToken = import.meta.env.VITE_PUBLIC_STOREFRONT_ACCESS_TOKEN;

const getBundleComponents = async (productHandle: string) => {
  const shopDomain = window.shopDomain;

  try {
    const response = await fetch(`https://${shopDomain}/api/2024-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({
        query: `
        ${fragments}

        query product($country: CountryCode, $language: LanguageCode, $handle: String!)
          @inContext(country: $country, language: $language) {
            product(handle: $handle) {
              variants(first: 250) {
                nodes {
                  ...ProductVariantWithComponentsFields
                }
              }
            }
          }
        `,
        variables: {
          country: window.country,
          language: window.language,
          handle: productHandle,
        },
      }),
    });

    const data = await response.json();

    if (data.errors) {
      // eslint-disable-next-line no-console
      console.error(data.errors);
      return [];
    }

    if (data.data == null || data.data.product == null || data.data.product.variants == null) {
      return [];
    }

    return data.data.product.variants.nodes as ProductVariantWithComponentsFields[];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return [];
  }
};

export { getBundleComponents };
